import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import { UpdateUser, PingModality, DicomSend as DicomSendAPI } from '../../../../api'

export default function DicomSend({dialogState, user}) {

    const [ modality, setModality ] = useState({})
    const [ modalities, setModalities ] = useState(user.modalities || [])
    const [ error, setError ] = useState()
    const [ loading, setLoading ] = useState()

    const setModalityData = e =>
        setModality(o => ({...o, [e.target.name]: e.target.value}))

    const saveModalities = () =>
        modality.desc && setModalities(m => {
            const copyM = [...m]
            const i = copyM.findIndex(e=>e.desc===modality.desc)
            if (i >= 0)
                copyM[i] = modality
            else
                copyM.push(modality)
            UpdateUser(user.id, {modalities: copyM}).catch(e=>e)
            return copyM
        })

    const pingModality = () => {
        setLoading(true)
        PingModality(modality)
            .then(()=>setError({color:'success', text: 'Ping successful'}))
            .then(()=>saveModalities())
            .catch(()=>setError({color:'error', text: 'Ping failed'}))
            .finally(()=>setLoading())
    }

    const send = () => {
        setLoading(true)
        DicomSendAPI(dialogState.studyId, modality)
            .then(()=>dialogState.onSend && dialogState.onSend(dialogState))
            .then(saveModalities)
            .catch(()=>setError({color:'error', text: 'Send failed'}))
            .finally(()=>setLoading())
    }

    useEffect(()=>setError(),[dialogState.open, modality])

    const modalityListed = React.useMemo(()=>modalities.some(e=>e.desc===modality.desc),[modalities,modality.desc])

    const deleteModality = () => {
        setModalities(m => {
            const copyM = [...m]
            const i = copyM.findIndex(e=>e.desc===modality.desc)
            if (i >= 0) {
                copyM.splice(i, 1)
                UpdateUser(user.id, {modalities: copyM}).catch(e=>e)
            }
            return copyM
        })
        setModality({})
    }

    return (
        <Dialog open={dialogState.open || false} onClose={dialogState.onClose} fullWidth maxWidth="xs">
            <DialogTitle>DICOM Send</DialogTitle>
            <DialogContent>
                {error?.text && (<DialogContentText sx={{mb:2}} color={error.color}>{error.text}</DialogContentText>)}
                {!!modalities.length && (
                    <FormControl sx={{mb: 1}} fullWidth variant="standard">
                        <TextField
                        id="modality"
                        value={(modalityListed && modality.desc) || ''}
                        label="Modalities"
                        onChange={e => setModality(modalities.find(a=>a.desc===e.target.value))}
                        variant="standard"
                        disabled={loading}
                        select
                        >
                        {modalities.map((e) => (
                            <MenuItem key={e.desc} value={e.desc}>
                                {e.desc}
                            </MenuItem>
                        ))}
                        </TextField>
                    </FormControl>
                )}
                <TextField
                    id="desc"
                    label="Description"
                    name="desc"
                    fullWidth
                    variant="standard"
                    value={modality.desc || ''}
                    onChange={setModalityData}
                    disabled={loading || modalityListed}
                />
                <TextField
                    id="aetitle"
                    label="AE Title"
                    name="aetitle"
                    fullWidth
                    variant="standard"
                    value={modality.aetitle || ''}
                    onChange={setModalityData}
                    required
                    disabled={loading}
                />
                <TextField
                    id="host"
                    label="Hostname"
                    name="host"
                    fullWidth
                    variant="standard"
                    value={modality.host || ''}
                    onChange={setModalityData}
                    required
                    disabled={loading}
                />
                <TextField
                    id="port"
                    label="Port"
                    name="port"
                    type="number"
                    fullWidth
                    variant="standard"
                    value={modality.port || ''}
                    onChange={setModalityData}
                    required
                    disabled={loading}
                />
                <TextField
                    id="uaetitle"
                    label="User AE Title"
                    name="uaetitle"
                    fullWidth
                    variant="standard"
                    value={modality.uaetitle || ''}
                    onChange={setModalityData}
                    disabled={loading}
                />
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={()=>setModality({})}>Clear</Button>
                <Button disabled={loading || !modalityListed} onClick={deleteModality}>Delete</Button>
                <Button disabled={loading} onClick={dialogState.onClose}>Close</Button>
                <Box flexGrow={1} />
                <Button disabled={loading} onClick={pingModality}>Ping</Button>
                <Button disabled={loading} onClick={send}>Send</Button>
            </DialogActions>
        </Dialog>
    )
}